import { FeatureFlagsService } from '@widgets/shared/services/featureFlagsService'

// tm::features::widget::<feature>
type Features = 'email-attachments'

export class MessengerFeatureFlagsService extends FeatureFlagsService<Features> {}

export const messengerFeatureFlagsService = new MessengerFeatureFlagsService()
